const PHRASES = ["Bespoke Tailoring", "Made to Measure", "Mumbai", "Santacruz · Bandra", "Book a Fitting"];

// Purely a visual transition — no CTA here by design.
export const Marquee = () => {
  const strip = (
    <>
      {PHRASES.map((p) => (
        <span key={p} className="flex items-center shrink-0">
          <span className="font-display text-1xl sm:text-1xl lg:text-1xl font-normal text-[#faf8f5]/90 whitespace-nowrap px-3">{p}</span>
          <span className="font-accent italic text-1xl text-[#c5a059] px-1">—</span>
        </span>
      ))}
    </>
  );

  return (
    <section data-testid="editorial-marquee-section" aria-hidden="true" className="bg-[#0b0b0c] border-y border-white/10 py-3 overflow-hidden">
      <div className="marquee-track">
        <div className="flex shrink-0">{strip}</div>
        <div className="flex shrink-0">{strip}</div>
      </div>
    </section>
  );
};
